import {
  Paper,
  Typography,
  Button,
  IconButton,
  Popover,
  TablePagination,
  Drawer,
  TextField,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
} from '@material-ui/core'
import React from 'react'
import {
  RemoveCircleOutlineOutlined as RemoveCircleOutlineOutlinedIcon,
  Settings as SettingsIcon,
} from '@material-ui/icons'
import ClearIcon from '@mui/icons-material/Clear'
import CircularProgress from '@material-ui/core/CircularProgress'
import { useSelector, useDispatch } from 'react-redux'

import InputAdornment from '@material-ui/core/InputAdornment'
import SearchIcon from '@material-ui/icons/Search'
import GetAppIcon from '@material-ui/icons/GetApp'
import BrushIcon from '@mui/icons-material/Brush'
import { makeStyles } from '@material-ui/core/styles'
import CustomizeColumn from './CustomizeColumn'
import CustomPaginationActions from '../../components/CustomTable/CustomPaginationActions'
import Filters from '../TcinInfo/Filters'
import {
  generatePDFAPI,
  generateContactSheetPDFAPI,
  generateContactSheetFinalPDFAPI,
  generateCompactShotSheetPDFAPI,
} from '../../store/TcinInfo/actionCreator'
import apiConfig from '../../apiConfig'
import { CSVLink } from 'react-csv'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import { formatCSVData } from '../TcinInfo/mapper'
import { isEmpty } from 'lodash'
import { uniq } from 'lodash'
import { withAuth } from '@praxis/component-auth'
import ConfirmationDailog from '../../components/ConfirmationDailog'
import { removeTcinsFromProjectAction } from '../../store/Dashboard/actionCreator'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import { setInBrowserStorage } from '../Workflow/utils'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '8px',
    width: '100%',
  },
  actionMenu: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  topMenu: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginTop: 8,
  },
  paginationToolbar: {
    marginLeft: 'auto',
  },
  inputProps: {
    height: 40,
    padding: '0 8px',
  },
  inputWidth: {
    width: 423,
  },
  calenderInputProps: {
    height: 40,
    padding: '0 14px',
  },
  calenderAdornedEnd: {
    paddingRight: 0,
  },
  inputLabel: {
    transform: 'translate(14px, 13px) scale(1)',
  },
  popover: {
    width: 896,
    padding: '20px 30px',
  },
}))

const TableToolbar = (props) => {
  const {
    selected,
    rows,
    originalRows,
    setRows,
    userColumns,
    customizeColumns,
    setCustomizeColumns,
    rowsPerPage,
    page,
    handleChangePage = () => {},
    handleChangeRowsPerPage = () => {},
    projectId,
    getProjectInfo,
    columns,
    isProducer,
    viewType,
    setViewType,
    updateUserView,
    totalCount,
    accessToken = '',
    lanId = '',
    isRemoveDisabled = true,
    isEnableCustomColumns = true,
    tabPage = '',
    subTabPage = '',
    packagingAssetUploadedDate = '',
    handlePackagingAssetUploadedDateChange = () => {},
    settingsIcon = true,
    showWorkflowButton = true,
    showDataButton = true,
    showSheetButton = true,
    selectionText = true,
  } = props
  const classes = useStyles()
  const dispatch = useDispatch()
  const [customColumnAnchor, setCustomColumnAnchor] = React.useState(null)
  const [openFilters, setOpenFilters] = React.useState(false)
  const [progressSheet, setProgressSheet] = React.useState(0)
  const [downloadAnchorEl, setDownloadAnchorEl] = React.useState(null)
  const [downloadSheetAnchorEl, setDownloadSheetAnchorEl] = React.useState(null)
  const [search, setSearch] = React.useState('')
  const [searchInput, setSearchInput] = React.useState('')
  const [searchTermError, setSearchTermError] = React.useState('')
  const [searchType, setSearchType] = React.useState('TCIN_OR_DPCI')
  const [csvData, setCsvData] = React.useState({
    headers: [],
    data: false,
  })
  const csvBtn = React.useRef()
  const [openConfirmation, setOpenConfirmation] = React.useState(false)
  const isPackagingLikeTab =
    subTabPage === 'packaging' || subTabPage === 'additionalImages'

  const altImageCount = useSelector((state) => {
    const {
      dashboardReducer: { projectDataReducer: { max_alt_count = 0 } = {} } = {},
    } = state
    return max_alt_count
  })

  const onPageChangeClick = (event, page = Number(0)) => {
    getProjectInfo(page, rowsPerPage, search, searchType)
    handleChangePage(event, page)
  }

  const onRowsPerPageChangeClick = (event) => {
    getProjectInfo(page, event.target.value, search, searchType)
    handleChangeRowsPerPage(event, event.target.value)
  }

  React.useEffect(() => {
    return () => {
      setSearch([])
      setSearchInput([])
    }
  }, [])

  React.useEffect(() => {
    if (isPackagingLikeTab && searchType !== 'TCIN_OR_DPCI') {
      setSearchType('TCIN_OR_DPCI')
      setSearch([])
      setSearchInput([])
      setSearchTermError('')
    }
  }, [isPackagingLikeTab, searchType])

  React.useEffect(() => {
    if (
      !isEmpty(csvData.data) &&
      csvBtn.current !== null &&
      csvBtn.current.link !== null
    ) {
      setTimeout(() => {
        csvBtn.current !== null && csvBtn.current.link.click()
        setCsvData({ ...csvData, data: false })
      })
    }
  }, [csvData])

  const handleFilterClose = () => {
    setOpenFilters(false)
  }
  const handleDownloadShotSheets = () => {
    closeDownloadSheet()
    setProgressSheet(1)
    dispatch(
      generatePDFAPI(
        selected.map((r) => r.tcin),
        accessToken,
        downloadCallBack
      )
    )
  }

  const handleDownloadContactSheets = () => {
    closeDownloadSheet()
    setProgressSheet(1)
    dispatch(
      generateContactSheetPDFAPI(
        selected.map((r) => r.tcin),
        accessToken,
        downloadCallBack
      )
    )
  }

  const handleDownloadContactSheetsFinal = () => {
    closeDownloadSheet()
    setProgressSheet(1)
    dispatch(
      generateContactSheetFinalPDFAPI(
        selected.map((r) => r.tcin),
        accessToken,
        downloadCallBack
      )
    )
  }

  const handleDownloadCompactShotSheets = () => {
    closeDownloadSheet()
    setProgressSheet(1)
    dispatch(
      generateCompactShotSheetPDFAPI(
        selected.map((r) => r.tcin),
        accessToken,
        downloadCallBack
      )
    )
  }

  const closeDownload = () => {
    setDownloadAnchorEl(null)
  }

  const closeDownloadSheet = () => {
    setDownloadSheetAnchorEl(null)
  }

  const downloadCallBack = (downlistPercentages = '0') => {
    if (downlistPercentages === 100) {
      setProgressSheet(0)
    } else {
      setProgressSheet(downlistPercentages)
    }
  }

  const removeTcinsFromProject = () => {
    let data = {
      tcins: selected.map((o) => o.tcin),
    }
    dispatch(
      removeTcinsFromProjectAction({
        data,
        projectId,
        lanId,
        successCallBack: getProjectInfo,
      })
    )
  }

  const onCloseCustomizeWindow = () => {
    setCustomColumnAnchor(null)
  }

  const onClickDownload = (event, value) => {
    closeDownload()
    let csvHeaders = []
    if (event.currentTarget.dataset.item === 'all') {
      csvHeaders = columns
        .filter((o) => {
          return o.id !== undefined && o.csvDownload !== false
        })
        .map((obj) => {
          return {
            key: obj.id,
            label: obj.headerName,
          }
        })
    } else {
      csvHeaders = columns
        .filter((col) => {
          return (
            (typeof col.showColumn === 'function' ||
            typeof col.showNestedRow === 'function'
              ? col.showColumn(customizeColumns) ||
                col.showNestedRow(customizeColumns)
              : customizeColumns[col.id].selected) && col.csvDownload !== false
          )
        })
        .map((obj) => {
          return {
            key: obj.id,
            label: obj.headerName,
          }
        })
    }
    setCsvData({
      headers: csvHeaders,
      data: formatCSVData(selected, altImageCount, 'csv', 'projectInfo'),
    })
  }

  const openDownload = (event) => {
    setDownloadAnchorEl(event.currentTarget)
  }

  const openDownloadSheet = (event) => {
    setDownloadSheetAnchorEl(event.currentTarget)
  }

  const onChangeSearch = (e) => {
    const tcinRegex = /^[0-9]{5,10}$/
    const dpciRegex = /^[0-9]{3}-[0-9]{2}-[0-9]{4}$/

    let tcinsList = e.target.value
      ? uniq(e.target.value.split(/[^\d\w-]+/g))
      : []
    let validItemList
    let helperText = ''

    if (searchType === 'TCIN_OR_DPCI') {
      validItemList = tcinsList.filter(
        (item) => tcinRegex.test(item) || dpciRegex.test(item)
      )
      const invalidItemList = tcinsList.filter(
        (item) => !tcinRegex.test(item) && !dpciRegex.test(item)
      )
      helperText = invalidItemList?.length
        ? `${'Invalid TCIN/DPCI(s) : ' + invalidItemList?.join(',')}`
        : ''
    }
    setSearchTermError(helperText)
    setSearch((validItemList || tcinsList || []).join(', ').trim())
    setSearchInput(tcinsList.join(', ').trim())
  }
  const handleKeyPress = (event) => {
    if (event.key === 'Enter' || event.key === 'Tab') {
      getProjectInfo(page, rowsPerPage, search, searchType)
    }
  }

  const clearSearch = () => {
    setSearch([])
    setSearchInput([])
    setSearchTermError('')
    getProjectInfo(page, rowsPerPage, [], searchType)
  }

  const onSearchTypeChange = (findType = '') => {
    setSearch([])
    setSearchInput([])
    setSearchTermError('')
    setSearchType(findType || '')
  }

  const showWorkflow = () => {
    const tcinList = selected.map((obj) => obj?.tcin)
    const finalTcinList = Array.from(new Set(tcinList))
    setInBrowserStorage(
      'newTab',
      JSON.stringify({
        searchTerm: 'SEARCH',
        searchValue: finalTcinList,
      })
    )
    window.open(window.location.origin + '/workflow', '_blank')
  }

  return (
    <Paper className={classes.root} elevation={0}>
      <div className={classes.topMenu}>
        <Typography variant="h6" style={{ fontWeight: 400 }}>
          Showing {rows?.length} TCINs of {totalCount}
        </Typography>
        <div className={classes.paginationToolbar}>
          {subTabPage === 'default' && (
            <FormControl component="fieldset">
              <RadioGroup
                row
                name="ViewType"
                onChange={(e) => onSearchTypeChange(e.target.value)}
                value={searchType}
              >
                <FormControlLabel
                  control={<Typography variant="body1">Search By:</Typography>}
                  sx={{ color: 'black', paddingLeft: '10px' }}
                />
                <FormControlLabel
                  value="TCIN_OR_DPCI"
                  control={<Radio />}
                  label="TCIN/DPCI"
                  sx={{
                    color: searchType === 'TCIN_OR_DPCI' ? 'black' : 'gray',
                  }}
                />
                <FormControlLabel
                  value="KEY_WORDS"
                  control={<Radio />}
                  label="Key Words"
                  sx={{ color: searchType === 'KEY_WORDS' ? 'black' : 'gray' }}
                />
              </RadioGroup>
            </FormControl>
          )}
          {isPackagingLikeTab && (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                autoOk
                variant="inline"
                inputVariant="outlined"
                InputProps={{
                  classes: {
                    input: classes.calenderInputProps,
                    adornedEnd: classes.calenderAdornedEnd,
                  },
                }}
                disableFuture
                value={packagingAssetUploadedDate}
                format="yyyy-MM-dd"
                label={'Assets Uploaded From'}
                onChange={(date) =>
                  handlePackagingAssetUploadedDateChange(date)
                }
                style={{ width: '165px', marginRight: '10px' }}
              />
            </MuiPickersUtilsProvider>
          )}
          <TextField
            type="text"
            autoFocus
            label={
              searchType === 'TCIN_OR_DPCI'
                ? 'Find TCINs or DPCIs in this project'
                : 'Find by Keywords in this project'
            }
            id="find-project"
            onKeyDown={handleKeyPress}
            InputLabelProps={{
              classes: {
                outlined: classes.inputLabel,
              },
            }}
            onChange={onChangeSearch}
            helperText={searchTermError}
            FormHelperTextProps={{
              style: { color: '#CC0000' },
            }}
            value={searchInput}
            InputProps={{
              classes: {
                inputAdornedEnd: classes.inputProps,
                adornedEnd: classes.inputWidth,
              },
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="find_project"
                    edge="end"
                    onClick={() =>
                      getProjectInfo(page, rowsPerPage, search, searchType)
                    }
                  >
                    <SearchIcon />
                  </IconButton>
                  {search !== '' && (
                    <IconButton
                      aria-label="find_project"
                      edge="end"
                      onClick={clearSearch}
                    >
                      <ClearIcon />
                    </IconButton>
                  )}
                </InputAdornment>
              ),
            }}
            variant="outlined"
          />
        </div>
        {/* <Badge badgeContent={5} color="secondary">
          <Button
            variant="outlined"
            // disabled={!isFilterEnabled}
            startIcon={<FilterListIcon />}
            className={classes.button}
            onClick={() => setOpenFilters(true)}
          >
            <span className={classes.filtersSelected}></span>
            Filters
          </Button>
        </Badge> */}
        <ConfirmationDailog
          open={openConfirmation}
          alertMessage="Are you sure?"
          message={`${selected?.length} selected tcins will be removed from this project`}
          cancelText="Cancel"
          agreeText="Confirm"
          onConfirm={() => {
            removeTcinsFromProject()
            setOpenConfirmation(false)
          }}
          onClose={() => setOpenConfirmation(false)}
        />
        <Drawer
          classes={{
            paper: classes.filterDrawer,
          }}
          anchor="right"
          open={openFilters}
          onClose={handleFilterClose}
        >
          <Filters closeDialog={handleFilterClose} />
        </Drawer>
      </div>
      <div className={classes.actionMenu}>
        {selectionText && (
          <Typography variant="body1" style={{ fontWeight: 400 }}>
            {selected?.length} Selected
          </Typography>
        )}
        {isProducer && !apiConfig.isPol && (
          <Button
            disabled={!(selected?.length > 0 && !isRemoveDisabled)}
            onClick={() => {
              setOpenConfirmation(true)
            }}
            startIcon={<RemoveCircleOutlineOutlinedIcon />}
          >
            Remove From Project
          </Button>
        )}

        {showWorkflowButton && (
          <Button
            disabled={!(selected?.length > 0)}
            onClick={showWorkflow}
            startIcon={<BrushIcon />}
          >
            Workflow
          </Button>
        )}

        {/* <Button startIcon={<GetAppIcon />}>Data</Button> */}
        {showDataButton && (
          <Button
            variant="outlined"
            startIcon={<GetAppIcon />}
            onClick={openDownload}
            disabled={selected?.length === 0}
          >
            Data
          </Button>
        )}
        {csvData.data ? (
          <CSVLink
            ref={csvBtn}
            asyncOnClick
            filename={'tcinImageInfo.csv'}
            data={csvData.data}
            headers={csvData.headers}
          />
        ) : undefined}
        <Menu
          id="simple-menu"
          anchorEl={downloadAnchorEl}
          keepMounted
          open={Boolean(downloadAnchorEl)}
          onClose={closeDownload}
        >
          <MenuItem data-item="all" onClick={onClickDownload}>
            Download All Columns
          </MenuItem>
          <MenuItem data-item="visible" onClick={onClickDownload}>
            Download Visible Columns
          </MenuItem>
        </Menu>
        {showSheetButton && (
          <Button
            variant="outlined"
            startIcon={<GetAppIcon />}
            onClick={openDownloadSheet}
            disabled={selected?.length === 0 || progressSheet !== 0}
          >
            Sheets
            {progressSheet !== 0 && (
              <CircularProgress
                style={{
                  marginLeft: 8,
                }}
                thickness={6}
                size={20}
                variant="determinate"
                value={progressSheet}
              />
            )}
          </Button>
        )}
        {csvData.data ? (
          <CSVLink
            ref={csvBtn}
            asyncOnClick
            filename={'tcinImageInfo.csv'}
            data={csvData.data}
            headers={csvData.headers}
          />
        ) : undefined}
        <Menu
          id="simple-menu"
          anchorEl={downloadSheetAnchorEl}
          keepMounted
          open={Boolean(downloadSheetAnchorEl)}
          onClose={closeDownloadSheet}
        >
          <MenuItem data-item="shot-sheet" onClick={handleDownloadShotSheets}>
            Shot Sheets
          </MenuItem>
          <MenuItem
            data-item="contact-sheet"
            onClick={handleDownloadCompactShotSheets}
          >
            Compact Shot Sheets
          </MenuItem>
          <MenuItem
            data-item="contact-sheet"
            onClick={handleDownloadContactSheets}
          >
            Contact Sheets Source
          </MenuItem>

          <MenuItem
            data-item="contact-sheet"
            onClick={handleDownloadContactSheetsFinal}
          >
            Contact Sheets Final
          </MenuItem>
        </Menu>

        <TablePagination
          classes={{
            root: classes.paginationToolbar,
          }}
          component="div"
          rowsPerPageOptions={[
            50,
            100,
            200,
            { label: 'All', value: totalCount },
          ]}
          colSpan={3}
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={onPageChangeClick}
          onChangeRowsPerPage={onRowsPerPageChangeClick}
          ActionsComponent={CustomPaginationActions}
        />
        {settingsIcon && (
          <IconButton
            variant="outlined"
            onClick={(e) => setCustomColumnAnchor(e.currentTarget)}
            disabled={!isEnableCustomColumns}
          >
            <SettingsIcon />
          </IconButton>
        )}
        <Popover
          open={Boolean(customColumnAnchor)}
          anchorEl={customColumnAnchor}
          onClose={onCloseCustomizeWindow}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          classes={{
            paper: classes.popover,
          }}
        >
          <CustomizeColumn
            userColumns={userColumns}
            customColumns={customizeColumns}
            setCustomColumns={setCustomizeColumns}
            onDiscardChanges={onCloseCustomizeWindow}
            onPopupClose={setCustomColumnAnchor}
            viewType={viewType}
            setViewType={setViewType}
            updateUserView={updateUserView}
          />
        </Popover>
      </div>
    </Paper>
  )
}

const mapAuthToProps = (auth) => {
  return {
    accessToken: auth.session?.userInfo?.accessToken,
    lanId: auth.session?.userInfo?.lanId,
  }
}

export default withAuth(mapAuthToProps)(TableToolbar)
